import React from 'react';
import styled from 'styled-components';
import MobileNavbarContext from '../mobile-navbar-context';

// Credit goes to Hamburgers' implementation from https://jonsuh.com/hamburgers/
// We're using the 'spring' type.
const size = 15;
const Hamburger = styled.ul`
  width: ${size}px;
  height: ${size}px;
  list-style: none;
  margin: ${-0.5 * size}px 0 0 0;
  padding: 0;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateZ(0);
  color: #fff;
`;

const strokeWidth = 2;
const Stick = styled.li`
  width: 100%;
  border: 0;
  border-bottom: ${strokeWidth}px solid #fff;
  position: absolute;
`;

const toCrossTopTiming = 'cubic-bezier(0.33333, 0.66667, 0.66667, 1)';
const toBurgerTopTiming = 'cubic-bezier(0.33333, 0, 0.66667, 0.33333)';
const toCrossTransformTiming = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const toBurgerTransformTiming = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
const pct = (2 - Math.sqrt(2)) / 2 / 2;
const hamOffset = 0.5 * size;
const bottomOffset = (1 - pct) * size;

const Top = styled(Stick)`
  top: ${pct * size - 0.5 * strokeWidth}px;
  transition: opacity 0s 130ms linear;
  transition-delay: ${props => (props.expanded ? 220 : 130)}ms;
  opacity: ${props => (props.expanded ? 0 : 1)};
`;

const Ham = styled(Stick)`
  top: ${props => (props.expanded ? 0 : (hamOffset - 0.5 * strokeWidth))}px;
  transform: ${props => props.expanded && `translateY(${hamOffset}px) rotate(45deg)`};
  transition: ${props => (props.expanded
    ? `top 100ms 150ms ${toBurgerTopTiming}, transform 130ms 220ms ${toBurgerTransformTiming}`
    : `top 100ms 200ms ${toCrossTopTiming}, transform 130ms ${toCrossTransformTiming}`)
};
`;

const Bottom = styled(Stick)`
  top: ${props => (props.expanded ? 0 : (bottomOffset - 0.5 * strokeWidth))}px;
  transform: ${props => props.expanded && `translateY(${hamOffset}px) rotate(-45deg)`};
  transition: ${props => (props.expanded
    ? `top 200ms ${toBurgerTopTiming}, transform 130ms 220ms ${toBurgerTransformTiming}`
    : `top 200ms 200ms ${toCrossTopTiming}, transform 130ms ${toCrossTransformTiming}`)
};
`;

export default function MenuToggle() {
  const { state: { expanded }, dispatch } = React.useContext(MobileNavbarContext);

  function onToggle(e) {
    e.preventDefault();
    dispatch({ type: 'toggle', payload: !expanded });
  }

  return (
    <a href="#" className="mobile-nav-link menu-toggle" onClick={onToggle}>
      <Hamburger>
        <Top expanded={expanded} />
        <Ham expanded={expanded} />
        <Bottom expanded={expanded} />
      </Hamburger>
    </a>
  );
}
